import MaxPainLevel from "./MaxPainLevel";

export default MaxPainLevel;
